import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Wyoming Department of Health - Medicaid Waiver Applicant Portal", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  style: {"text-align":"left"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "Welcome to the Medicaid Waiver Applicant Portal. This site will allow you to submit an application for the Medicaid Waivers.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { key: 1 }

import { onMounted, ref } from 'vue';
    import { useAuth0 } from "@/Services/Auth0/auth0-plugin";
    
export default /*#__PURE__*/_defineComponent({
  __name: 'SiteHome',
  setup(__props) {

    console.log("api from env: " + process.env.VUE_APP_PORTAL_API)
    
    const auth0 = useAuth0();
    const getAccessToken = async () => {
        if (!auth0) {
            return null;
        }

        return await auth0.getAccessToken();
    };
    const loadingData = ref(true)
        
    let unregistered = ref(true)
    let registered = ref(false)
    let isAuthenticated = false
    
    onMounted(async () => {
        try {
            const token = await getAccessToken();

            if (!token) {
                unregistered.value = true;
                registered.value = false;
            } else {
                unregistered.value = false;
                registered.value = true;
                isAuthenticated = auth0 ? auth0.isAuthenticated.value : false;
                console.log('Application Status Page is auth0 authenticated: ' + isAuthenticated);
            }
        } catch {
            console.log('Not Authenticated.');
        } finally {
            loadingData.value = false;
        }
    });    


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (loadingData.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          (_unref(unregistered))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createTextVNode(" We recommend that you begin by "),
                _createVNode(_component_router_link, { to: { name: 'register' } }, {
                  default: _withCtx(() => [
                    _createTextVNode("Registering")
                  ]),
                  _: 1
                }),
                _createTextVNode(" with the site prior to submitting an application. This will allow you to return to this site and see the status of your application, as well as provide additional information to the Wyoming Department of Health (WDH) as needed. A valid email address is required in order to register. ")
              ]))
            : _createCommentVNode("", true),
          _hoisted_7,
          (_unref(registered))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createTextVNode(" You are registered and logged into the site and you can proceed directly to the "),
                _createVNode(_component_router_link, { to: { name: 'application' } }, {
                  default: _withCtx(() => [
                    _createTextVNode("Application")
                  ]),
                  _: 1
                }),
                _createTextVNode(" page and submit without being able to return and update or track your application, or if you have submitted your application, you can go to the "),
                _createVNode(_component_router_link, { to: { name: 'application-status' } }, {
                  default: _withCtx(() => [
                    _createTextVNode("Application Status")
                  ]),
                  _: 1
                }),
                _createTextVNode(" page if your application has already been submitted. ")
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 64))
}
}

})